export default __webpack_public_path__ + "static/media/vacation.75e69ade.png";